import React from 'react';
import { Typography } from '@mui/material'; 
import { Divider } from '@mui/material';

export default function About() {
  return (
    <div className="about-app">
      <div className="about-logo-container">
        <div className="company-Logo"></div>
      </div>
      <Divider />
      <Typography variant="body1" className="description">
        Network Insight addresses CSPs’ need for a technical data
        umbrella platform that provides engineering data correlations for all
        network related data inputs such as Performance Management,
        Configuration Management, Faults, Probes, Coverage and Drive Test in one
        centralized solution, thus enhancing the overall Network performance and
        customer experience.
      </Typography>
      <Divider />
    </div>
  );
}
